var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 7,
    fill: "#FF7C04"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4142 5.58579C21.6332 4.80474 20.3668 4.80474 19.5858 5.58579L6.85786 18.3137C6.07682 19.0948 6.07682 20.3611 6.85786 21.1421C7.63891 21.9232 8.90524 21.9232 9.68629 21.1421L21 9.82843L32.3137 21.1421C33.0948 21.9232 34.3611 21.9232 35.1421 21.1421C35.9232 20.3611 35.9232 19.0948 35.1421 18.3137L22.4142 5.58579ZM23 36L23 7L19 7L19 36L23 36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.ac0b47301998b93a09dbfbee352b9594.svg";
export { ForwardRef as ReactComponent };